import dayjs from 'dayjs';

import React, {useState, useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom'
import {useNavigate} from "react-router-dom";
import DOMPurify from "dompurify";

import {DEFAULT_CITY} from 'ultra/const/general';
import {normalizeRoute} from 'ultra/helpers/route';
import {formResponseMessageVariables, getDataFromControlChangeEvent} from 'ultra/helpers/form';
import {getClientCity, getClientConfig} from 'ultra/configs/general';
import {removeEmptyValuesFromObj} from  'ultra/helpers/utils'
import {isHiddenField, getFormErrors} from 'ultra/helpers/content';
import {Collapse} from '@mui/material';

// import LinearProgress from '@mui/material/LinearProgress';

import {isUndefined, isObject, isNull, isArray} from 'lodash';
import {isFile, isEmptyObj, isValidDate} from 'ultra/helpers/utils'; // isEmptyMessengerData

import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import {post, patch} from '../../Helpers/http';
import {useGlobalCustomContext} from '../../Helpers/context'
import {getDefaultValues} from '../../Helpers/content'
import {getConfirmData} from '../../Helpers/partner';
import {getTelegramMode} from '../../Helpers/telegram';

import {useToasterStore} from '../../Stores/toster';
import {useFormStore} from '../../Stores/form';
import {useBackdropPreloaderStore} from '../../Stores/backdropPreloader';

import AdaptiveDialog from '../../Components/Adaptive/Dialog';
import PreloaderForm from '../../Components/Preloaders/PreloaderForm';

import Form from './Form';

import ExchangeSummary from '../FormConfirm/ExchangeSummary'
import ExchangeBillPaymentSummary from '../FormConfirm/ExchangeBillPaymentSummary'
import ExchangeATMSummary from '../FormConfirm/ExchangeATMSummary'

// import Preloader from '../Preloaders/Preloader';

export default function FormContainer(props) {
  const {
    id,
    config,
    disabled,
    isEditMode,
    showSkeleton,

    notSaveToStorage,
    noActionButtons,
    additionalButtons,
    formActions,

    prepareData,
    
    afterSubmit,
    submitHandler,
    beforeSubmit,
    wrapToObjectBeforeSubmit,

    keyGenerator,

    hideInfoAboutSavedSession,
    onChange
  } = props;
  // showErrors, 
  // onInitHandler
  // const {showSuccess, showError} = useToasterStore();
  const {
    form,
    setForm,
    setFormField,
    clearForm,
    
    formErrors,
    setFormErrors,
    clearFormError,
    setFormError,

    formVisibleErrors,
    setVisibleErrors,
    clearVisibleError,
    setVisibleError
  } = useFormStore();

  const {userState} = useGlobalCustomContext();

  const {showSuccess} = useToasterStore();

  const formRef = useRef(null)

  // TODO: get bali from uri
  const {api} = getClientConfig(window);

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  // const [successDuration, setSuccessDuration] = useState(null);

  // const [successTimer, setSuccessTimer] = useState(null);
  // const [successInterval, setSuccessInterval] = useState(null);

  // const [progress, setProgress] = React.useState();

  const [confirm, setConfirm] = useState(null)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [inProgress, setInProgress] = useState(false)
  // const [ready, setReady] = useState(false)
  const [initFromSession, setInitFromSession] = useState(false)
  // const [errors, setErrors] = useState({})
  // const [firstSubmit, setFirstSubmit] = useState(true)
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false)

  const [isSubmitBtnDisabled, setIsSubmitBtnDisabled] = useState(false)

  const location = useLocation();
  const navigate = useNavigate();

  const {showBackdropPreloader, hideBackdropPreloader} = useBackdropPreloaderStore()

  const getFormStorageKey = (id) => {
    if (keyGenerator) return keyGenerator();

    if (!id) return null;

    const path = normalizeRoute(location.pathname);
    return "form_" + id.replace('${path}', path);
  }

  const storageKey = getFormStorageKey(id);

  const saveToStorage = (form) => {
    if (storageKey) {
      const saveOnClient = {};
      Object.keys(config?.fields).map(fieldId => {
        if (
          !isNull(form[fieldId])
          && config.fields[fieldId]?.type !== 'password'
          && config.fields[fieldId]?.type !== 'image'
          && config.fields[fieldId]?.type !== 'gallery'
          && config.fields[fieldId]?.type !== 'hidden'
          // && !config.fields[fieldId]?.default
          && !config.fields[fieldId]?.options?.system
        ) {
          saveOnClient[fieldId] = form[fieldId];
        }
      })

      setInitFromSession(null);
      if (!isEmptyObj(saveOnClient)) sessionStorage.setItem(storageKey, JSON.stringify({date: (new Date()).getTime(), form: saveOnClient}));
    }
  }

  const clearStorage = () => {
    sessionStorage.removeItem(storageKey);
  }

  useEffect(() => {
    return () => {
      // if (id && isEditMode) sessionStorage.removeItem(getFormStorageKey());

      setFormErrors({});
      setVisibleErrors({});
    }
  }, [])

  // used in wizard
  // useEffect(() => {
  //   if (!isEmptyObj(showErrors)) {
  //     setFirstSubmit(false);
  //     setFormErrors(showErrors);
  //     setVisibleErrors(showErrors);
  //   }
  // }, [showErrors])

  useEffect(() => {
    // attach location default template
    if (config?.fields) {
      // setIsSubmitBtnDisabled(!isEmptyObj(errors));
      const initData = getDefaultValues(props.content, config, userState, isEditMode);

      Object.keys(config.fields).map(id => {
        if (isHiddenField(config.fields[id], initData)) {
          if (initData[id]) delete initData[id];
        }
      })

      const storageKey = getFormStorageKey(id);
      let savedUserData = {};
      if (storageKey) {
        let data = sessionStorage.getItem(storageKey);

        if (data) {
          data = JSON.parse(data);

          // if more then 7 - days - clean
          if (!data.date || dayjs().diff(dayjs(new Date(data.date)), "day") > 7) {
            clearStorage();
            setInitFromSession(null);
          }
          else {
            savedUserData = data?.form;
            setInitFromSession(dayjs(new Date(data.date)).format('DD.MM.YYYY | HH:mm'));

            // const errors = getFormErrors(config?.fields, savedUserData, isEditMode)
            // setIsSubmitBtnDisabled(!isEmptyObj(errors));
          }
        }
      }

      let urlFormData = {}
      const url = new URL(window.location.href);
      const formdata = url.searchParams.get('formdata');
      if (formdata) {
        urlFormData = JSON.parse(decodeURIComponent(formdata));
      }
      // console.log(savedUserData)
      // console.log(initData)
      // console.log(urlFormData)
      setForm({...initData, ...urlFormData, ...savedUserData});

      // setup data from URL if it's present in config
      // TODO: it's risky
      // someone can change here fields which are not visible for user
      // TODO: it should wark only for visible fields
      // query.forEach((value, key) => {
      //   if (config.fields[key]) {
      //     initContent[key] = value;
      //   }
      // })
    }
  }, [config?.fields, userState?.user])

  const onBlurHandler = (e, field) => {
    // if prev active are same without duplicate
    const fieldsConfig = {
      [field.id]: config?.fields[field.id],
    }

    const formData = {...form};
    formData[field.id] = getDataFromControlChangeEvent(field, e, formData[field.id]);

    const err = getFormErrors(fieldsConfig, formData, isEditMode);

    if (formErrors[field.id] !== err[field.id]) setFormError(field.id, err[field.id]);
    if (formVisibleErrors[field.id] !== err[field.id]) setVisibleError(field.id, err[field.id]);
  }

  // ignoreErrorCheck
  const onChangeHandler = (e, field) => {
    // NEW DATA
    let newValue = getDataFromControlChangeEvent(field, e, form[field.id]);

    // setup null if no data
    // on backend it will be removed from node document
    if (
      isUndefined(newValue)
      || newValue === ''
      || (!isFile(newValue) && !isValidDate(newValue) && isObject(newValue) && isEmptyObj(newValue))
      || (isArray(newValue && newValue.length === 0))) {
        newValue = null;
    }

    setFormField(field.id, newValue);

    // if (window.debug) console.log(newForm)

    const newForm = {...form};
    newForm[field.id] = newValue;

    if (!notSaveToStorage) saveToStorage(newForm);

    // ERRORS
    const err = getFormErrors(config?.fields, newForm, isEditMode)

    if (!isEmptyObj(err)) console.error(err);

    if (!err[field.id] && formErrors[field.id]) clearFormError(field.id);
    if (!err[field.id] && formVisibleErrors[field.id]) clearVisibleError(field.id);

    // errors should be save on separate object
    // because on blur it will be used to detect is errors present in form
    setFormErrors(err);
    if (err[field.id]) setVisibleError(field.id, err[field.id]);

    if (isEmptyObj(formVisibleErrors)) showFormError(null);
    // if (!firstSubmit) showFormError('У формі присутні помилки');

    if (onChange) onChange({id: field.id, newValue});
  }

  // const onInitHandlerDefault = ({errors}) => {
  //   // setIsSubmitBtnDisabled(!isEmptyObj(errors));
  // }

  const trimTextFields = (data) => {
    Object.keys(config.fields).map(id => {
      if (typeof data[id] === 'string') {
        data[id] = data[id].trim();
      }
    });
    return data;
  }

  const formatValuesByType = (data) => {
    Object.keys(config.fields).map(id => {
      if (data[id] && config.fields[id]?.type === 'email') {
        data[id] = data[id].toLowerCase();
      }
    });
    return data;
  }

  const clearFormValuesByType = (data) => {
    let wasUpdated = false
    Object.keys(config.fields).map(id => {
      if (data[id] && config.fields[id]?.type === 'list') {
        data[id] = data[id].filter(item => {
          if (item.trim().length > 0) {
            return true
          }
          else {
            wasUpdated = true
            return false
          }
        });
      }
    });

    if (wasUpdated) setForm(data)
    return data;
  }

  const showFormError = (err) => {
    // showError({snackbarMessage: err});
    setError(err);
  }

  const showFormSuccess = (snackbarMessage) => { // snackbarDuration
    setSuccess(snackbarMessage);
    // setSuccessDuration(snackbarDuration);

    setTimeout(() => {
      let bot = getTelegramMode();
      let el = window;
      if (bot) {
        el = document.getElementById("root");
      }
      el.scrollTo(0, document.getElementsByClassName('FormSuccess')[0].offsetTop);
    }, 200)
    // else {
    //   clearSuccess();
    //   // if (snackbarDuration) {
    //   //   setProgress(snackbarDuration/1000)
    //   //   setSuccessInterval(setInterval(() => {
    //   //     setProgress((prevProgress) => (prevProgress > 0 ? prevProgress - 1 : 0 ));
    //   //   }, 1000))

    //   //   setSuccessTimer(setTimeout(() => {    
    //   //     clearSuccess();
    //   //   }, snackbarDuration))
    //   // }
    //   // else {
    //   //   clearSuccess();
    //   // }
    // }
  }

  // const clearSuccess = () => {
  //   // if (successTimer) clearTimeout(successTimer);
  //   // if (successInterval) clearInterval(successInterval);
  //   setSuccess(null);
  //   // setSuccessDuration(null);
  // }

  const onSubmitHandler = (ignoreApprove, confirmData) => {
    if (inProgress) return;

    // if (firstSubmit) setFirstSubmit(false);

    if (isSubmitBtnDisabled) return;

    setInitFromSession(null);

    console.log("onSubmitHandler")
    const errors = getFormErrors(config?.fields, form, isEditMode)
    console.log(errors)

    let data = clearFormValuesByType(form)
    data = removeEmptyValuesFromObj(data);

    if (!isEmptyObj(errors)) {
      // setIsSubmitBtnDisabled(true);

      setFormErrors(errors);
      setVisibleErrors(errors);

      showFormError('У формі присутні помилки');

      // TODO: fix, it's not scroll
      // formRef.current?.scrollIntoView({ behavior: 'smooth' });
      // make array of ref for each field, if has error, scroll to

      // setFirstSubmit(true);
      setConfirmLoading(false);
      setInProgress(false);
      setIsConfirmDialogOpen(false);
      return;
    }

    if (config.form.confirm && !confirmData && !ignoreApprove) {
      setIsConfirmDialogOpen(true);

      setConfirmLoading(true);

      if (confirm?._oid) data._oid = confirm._oid;

      // getConfirmData(config?.form?.confirm, config?.partner?.partner, config?.partner?.product, data)
      getConfirmData(config?.form?.confirm, config?.partner?.id, config?.partner?.form, data)
          // .promise
          .then(result => {
            if (result?.confirm?.other) {
              setConfirm(null);
              onSubmitHandler(false, result); // result
            }
            else {
              setConfirm(result);
              setConfirmLoading(false);
            }
          })

      return;
    }

    setInProgress(true)

    setFormErrors({});
    setVisibleErrors({});
    // setFirstSubmit(true);
    // setIsSubmitBtnDisabled(false);
    showBackdropPreloader()

    const path = normalizeRoute(location.pathname)

    let url
    if (config.form.endpoint) {
      // TODO: CHECK where it's used // !!!!!!! revert changes woth additional parameter
      url = config.form.endpoint.includes('http') ? `${config.form.endpoint}` : `${api}${config.form.endpoint}`
      if (config.form.addCurrentPathToEndpoint) { url += path + location.search }
    } else {
      const city = getClientCity(window) || DEFAULT_CITY;
      // url = `${api}/partner/form/${city}/path${path}`
      url = `${api}/form/${city}/form${path}`
    }

    if (prepareData) {
      data = prepareData(data);
    }
    else {
      data = formatValuesByType(trimTextFields(data));
    }

    if (confirmData?._oid) {
      data._oid = confirmData._oid;
    }
    else if (confirm?._oid) {
      data._oid = confirm._oid;
    }

    if (beforeSubmit) beforeSubmit();

    if (submitHandler) {
      submitHandler(data);
      return;
    }

    const request = isEditMode ? patch : post

    // check permits for fields:
    // data.description = 'blb bla'
    // data._published = '1111111'
    // data._path_config = '222222'
    // data._parent = '\\biznes\\ukrayinskibiznesi'
    // data._parent = 123
    const launch = () => wrapToObjectBeforeSubmit ? request(url, wrapToObjectBeforeSubmit(data)) : request(url, data)

    launch()
      .then(async result => {
        if (afterSubmit) {
          await afterSubmit({result, content: data})
        }

        // apply template for success message
        let snackbarMessage
        if (config?.form?.successMessageNotValidated) {
          if (!result.page._published) {
            snackbarMessage = formResponseMessageVariables(config.form.successMessageNotValidated, result.page);
          }
          else {
            snackbarMessage = result.message || formResponseMessageVariables(config.form.successMessage, result.page);
          }
        }
        else {
          snackbarMessage = result.message || formResponseMessageVariables(config.form.successMessage, result);
        }

        // can be undefined, if no redirect after submit
        let onCloseRedirect = result?.redirect ? result.redirect : config.form.onCloseRedirect
        // const snackbarDuration = result?.delay ? result.delay : config.form.snackbarDuration

        setConfirmLoading(false);
        setInProgress(false);
        hideBackdropPreloader();

        if (config?.form?.confirm) {
          setIsConfirmDialogOpen(false);
        }

        clearForm();
        clearStorage();
        setConfirm(null);

        // clear state if not redirect
        if (onCloseRedirect) {
          clearForm();
          clearStorage();
          setConfirm(null);

          onCloseRedirect.includes('http') ?
            window.location.assign(onCloseRedirect)
            : navigate(onCloseRedirect)
        }
        else {
          if (config.form.successToNotify) {
            showSuccess({snackbarMessage}); // , onCloseRedirect, snackbarDuration
          }
          else {
            showFormSuccess(snackbarMessage); // snackbarDuration
          }
        }
      })
      .catch((e) => {
        hideBackdropPreloader();

        setConfirmLoading(false);
        setInProgress(false);
        setIsConfirmDialogOpen(false);
        // setIsSubmitBtnDisabled(false);
        // showError({snackbarMessage: e?.message});
        showFormError(e?.message);
      });
  }

  const onApprovetHandler = () => {
    onSubmitHandler(true)
  }

  const formActionsWrapper = {
      disable: function () {
        if (formActions) formActions.disable()
        setIsSubmitBtnDisabled(true)
      },
      enable: function () {
        if (formActions) formActions.enable()
        setIsSubmitBtnDisabled(false)
      }
  }

  const handleConfirmDialogClose = () => {
    setIsConfirmDialogOpen(false);
  }

  const cleanForm = () => {
    // sessionStorage.removeItem(getFormStorageKey());
    // setIsSubmitBtnDisabled(false);
    setFormErrors({});
    setVisibleErrors({});
    setError(null);
    setInitFromSession(null);
    // updateForm({});
    clearForm();
    clearStorage();
    setConfirm(null);
  }

  if (!form) return <PreloaderForm />
  if (!config) return <PreloaderForm />
  if (showSkeleton) return <PreloaderForm />

  return <>
    <Grid container spacing={2} ref={formRef} className='FormContainer'>
          {config?.fields && <>
            {!hideInfoAboutSavedSession && <Grid item xs={12} md={12} className='FormContainerCollapse'>
              <Collapse in={Boolean(initFromSession)}>
                <div className="FormContainerFromSession">
                  Ви почали і не завершили заповнення форми {initFromSession}
                  {/* <br/>  Ви можете продовжити або очистити форму */}

                  {/* <Button
                    variant="outlined"
                    className="CleanButton"
                    // size="small"
                    onClick={cleanForm}>
                      Очистити
                  </Button> */}
                  <span className='pseudoLink' onClick={cleanForm}>Очистити форму</span>
                </div>
              </Collapse>
            </Grid>}

            <Form
              disabled={inProgress || disabled}
              isEditMode={isEditMode}

              order={config?.fieldsOrder}
              fields={config?.fields}

              content={form}

              formActions={formActionsWrapper}

              // onInit={onInitHandlerDefault}
              onChange={onChangeHandler}
              onBlur={onBlurHandler}
            />
          </>}

          {config?.form?.submitNotice && !config?.form?.submitNoticePosition && <Grid item xs={12}>
            <div className='submitNotice'>
              <WarningAmberIcon />
              <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(config.form.submitNotice)}}></span>
            </div>
          </Grid>}

          {!success && !noActionButtons && config?.form?.submitText && <Grid item xs={12}>
            <div className={`FormButtons ${error ? "FormButtonsErrors" : ""}`}>
              {additionalButtons}
              <Button
                fullWidth
                disabled={inProgress || disabled || isSubmitBtnDisabled}
                variant="contained"
                className="submitButton"
                onClick={() => onSubmitHandler(false)}>
                  {config?.form?.submitText}
                  {error && <span className='error'>{error}</span>}
              </Button>
            </div>
          </Grid>}

          <Grid item xs={12}>
            <Collapse in={Boolean(success)}>
              <div className='FormSuccess'>
                <div className='result' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(success)}} />
                {/* {progress && <div>
                  <div>Це вікно буде закрито через {progress}</div>
                  <div className='successDurationProgress'>
                    <LinearProgress />
                  </div>
                </div>} */}
                <div className='btn'>
                  {/* <span className='pseudoLink' */}
                  <Button
                    fullWidth
                    variant="contained"
                    className="newRequestButton"
                    onClick={() => {
                      // clearSuccess()
                      setSuccess(null);
                      setError(null);
                      setFormErrors({});
                      setVisibleErrors({});

                      setTimeout(() => {
                        let bot = getTelegramMode();
                        let el = window;
                        if (bot) {
                          el = document.getElementById("root");
                        }
                        el.scrollTo(0, 0);
                      }, 200)
                    }}>
                      Нова заявка
                  </Button>
                  {/* </span> */}
                </div>
              </div>
            </Collapse>
          </Grid>

          {config?.form?.submitNotice && config?.form?.submitNoticePosition === "belowSubmit" && <Grid item xs={12}>
            <div className='submitNotice'>
              <WarningAmberIcon />
              <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(config.form.submitNotice)}}></span>
            </div>
          </Grid>}
      </Grid>
      <AdaptiveDialog
            open={isConfirmDialogOpen}
            onClose={handleConfirmDialogClose}
            title={<>
                {config?.form?.confirmTitle || 'Ваша заявка'}
            </>}
        >
            {config?.form?.confirm === 'exchange-summary' && <>
              <div className='FormContainerConfirm'>
                <div className='details'>
                  <ExchangeSummary form={form} config={config} workingHours={confirm?.workingHours} confirm={confirm?.confirm} loading={confirmLoading} onApprovetHandler={onApprovetHandler} />
                </div>
              </div>
            </>}

            {config?.form?.confirm === 'exchange-bill-payment-atm' && <>
              <div className='FormContainerConfirm'>
                <div className='details'>
                  <ExchangeATMSummary form={form} config={config} workingHours={confirm?.workingHours} confirm={confirm?.confirm} loading={confirmLoading} onApprovetHandler={onApprovetHandler} />
                </div>
              </div>
            </>}

            {config?.form?.confirm === 'exchange-bill-payment-summary' && <>
              <div className='FormContainerConfirm'>
                <div className='details'>
                  <ExchangeBillPaymentSummary form={form} config={config} workingHours={confirm?.workingHours} loading={confirmLoading} confirm={confirm?.confirm} onApprovetHandler={onApprovetHandler} />
                </div>
              </div>
            </>}

            {config?.form?.confirm !== 'exchange-summary'
              && config?.form?.confirm !== 'exchange-bill-payment-atm'
              && config?.form?.confirm !== 'exchange-bill-payment-summary'
              && <>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={onApprovetHandler}
                >
                    Відправити заявку
                </Button>
              </>
            }
            
        </AdaptiveDialog>
    </>;
}

// CAPTCHA
// import Captcha from './Captcha'
// const {filters} = configs;
// let {message, photos} = getTelegramMessage(content, config.fields, config.title, filters);

// if (config.captcha) {
//   setState({...state, showCaptcha: true});
// } else {
//   saveForm(photos)
// }

//   const onCaptchaClose = () => {
//     setState({...state, showCaptcha: false, backdropOpen: false})
//   }

//   const onCaptchaSubmit = (answers) => {
//     let {message, photos} = getTelegramMessage(content, config.fields, config.title);

//     message += `
// Капча:
// `;

//     const captcha = ['','',''];

//     config.captcha.options.map((q, i) => {
//       message += `  ${q}: ${answers[i]}
// `;
//       captcha[i] = `${q}: ${answers[i]}`;
//     })

//     saveForm(photos, captcha)
//   }

//       <Backdrop
//           sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
//           open={(showCaptcha)}
//       >
//           {showCaptcha &&
//               <Captcha
//                 values={config.captcha.options}
//                 inProgress={inProgress}
//                 description={config.captcha.description}
//                 onCaptchaClose={onCaptchaClose}
//                 onCaptchaSubmit={onCaptchaSubmit} />
//           }
//       </Backdrop>
